<template>
  <div
    ref="hammer-target"
    class="tree-selection"
  >
    <!-- <SlideTip class="slide-tip" /> -->
    <div
      v-if="showTip"
      class="popup-mask"
      @click="onClickTip"
    >
      <div class="popup">
        <h3>操作提示</h3>
        <p>点击树上的展览名称，进入展览的详情页面。</p>
        <p>点击下方标签进入不同分类下的展览页面。</p>
        <div class="image-wrapper">
          <img
            src="@/assets/image/gest-tap.png"
            alt=""
            draggable="false"
          >
        </div>
      </div>
      <img
        class="button-tip button-tip-1"
        src="@/assets/image/gest-tap.png"
        alt=""
        draggable="false"
      >
      <img
        class="button-tip button-tip-2"
        src="@/assets/image/gest-tap.png"
        alt=""
        draggable="false"
      >
      <img
        class="button-tip button-tip-3"
        src="@/assets/image/gest-tap.png"
        alt=""
        draggable="false"
      >
    </div>
    <div
      class="tree-swiper"
    >
      <!-- 标题 -->
      <div
        v-show="currentTab === 0"
        class="title-wrapper theme"
      >
        <h2 class="title">
          主题展览
        </h2>
      </div>
      <div
        v-show="(currentTab === 1) || (currentTab === -1)"
        class="title-wrapper wuyiba"
      >
        <h2 class="title">
          518特展
        </h2>
      </div>
      <div
        v-show="currentTab === 2"
        class="title-wrapper traditionModern"
      >
        <h2 class="title">
          传统与现代特展
        </h2>
      </div>

      <!-- 树和果子 -->
      <div
        :class="currentTab === 0 ? 'active' : ''"
        class="tree-wrapper theme"
      >
        <img
          v-for="index of 126"
          v-show="curFrameIdxBlue === index - 1 ||
            curFrameIdxBlue - 1 === index - 1 ||
            (curFrameIdxBlue === 0 && index === 126)
          "
          :key="index"
          class="tree"
          :src="`${$publicPath}tree-selection-frames/blue/blue_${(index-1).toString().padStart(4, '0')}.jpg`"
          alt=""
          draggable="false"
          @load="onImgLoad('blue', index - 1)"
          @error="onImgError('blue', index - 1)"
        >
        <TreeFruit
          v-for="item in exhibitionData.theme"
          :key="item.id"
          :class="item.id"
          :arrow-down="item.arrowDown"
          :text="item.title"
          :theme="item.theme"
          :link-to="`/ExhibitionDetailAnimation?exhibitionType=theme&exhibitionId=${item.id}`"
          draggable="false"
        />
      </div>
      <div
        :class="{
          'active': currentTab === 1,
          'initial-active': currentTab === -1,
        }"
        class="tree-wrapper wuyiba"
      >
        <img
          v-for="index of 131"
          v-show="curFrameIdxRed === index - 1 ||
            curFrameIdxRed - 1 === index - 1 ||
            (curFrameIdxRed === 0 && index === 131)
          "
          :key="index"
          draggable="false"
          class="tree"
          :src="`${$publicPath}tree-selection-frames/red/red_${(index-1).toString().padStart(4, '0')}.jpg`"
          alt=""
          @load="onImgLoad('red', index - 1)"
          @error="onImgError('red', index - 1)"
        >
        <TreeFruit
          v-for="item in exhibitionData.wuyiba"
          :key="item.id"
          :arrow-down="item.arrowDown"
          :text="item.title"
          :theme="item.theme"
          :class="item.id"
          :link-to="`/ExhibitionDetailAnimation${item.id === 'aa' ? 'ForJiaguo' : ''}?exhibitionType=wuyiba&exhibitionId=${item.id}`"
          draggable="false"
        />
      </div>
      <div
        :class="currentTab === 2 ? 'active' : ''"
        class="tree-wrapper traditionModern"
      >
        <img
          v-for="index of 125"
          v-show="curFrameIdxGreen === index - 1 ||
            curFrameIdxGreen - 1 === index - 1 ||
            (curFrameIdxGreen === 0 && index === 125)
          "
          :key="index"
          draggable="false"
          class="tree"
          :src="`${$publicPath}tree-selection-frames/green/green_${(index + 3).toString().padStart(4, '0')}.jpg`"
          alt=""
          @load="onImgLoad('green', index - 1)"
          @error="onImgError('green', index - 1)"
        >
        <TreeFruit
          v-for="item in exhibitionData.traditionModern"
          :key="item.id"
          :arrow-down="item.arrowDown"
          :text="item.title"
          :theme="item.theme"
          :class="item.id"
          :link-to="`/ExhibitionDetailAnimation?exhibitionType=traditionModern&exhibitionId=${item.id}`"
          draggable="false"
        />
      </div>
    </div>
    <SlideTip
      style="z-index: 1;"
    />
    <nav>
      <button
        class="theme"
        @click="onClickExhibTabBtn(0)"
      >
        主题展览
      </button>
      <button
        class="wuyiba"
        @click="onClickExhibTabBtn(1)"
      >
        518特展
      </button>
      <button
        class="traditionModern"
        @click="onClickExhibTabBtn(2)"
      >
        传统与现代特展
      </button>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TreeFruit from '@/components/TreeFruit.vue'
import exhibitionData from '@/exhibitionData.js'

export default {
  components: { TreeFruit },
  data() {
    return {
      exhibitionData,

      curFrameIdxBlue: 0,
      curFrameIdxRed: 0,
      curFrameIdxGreen: 0,

      imgStateListBlue: new Array(126),
      imgStateListRed: new Array(131),
      imgStateListGreen: new Array(125),

      intervalId: null,
    }
  },
  computed: {
    ...mapGetters({
      showTip: 'needShowTreeSelectionPageTip',
      currentTab: 'selectedTreeTabIdx',
    }),
  },
  created() {
  },
  mounted() {
    utils.registerSlideToRoute('hammer-target', 'Chart', this)
    this.intervalId = setInterval(() => {
      let idxBackup = 0
      switch (this.currentTab) {
      case -1:
        idxBackup = this.curFrameIdxRed
        do {
          this.curFrameIdxRed++
          if (this.curFrameIdxRed >= 131) {
            this.curFrameIdxRed = 0
          }
        } while (this.imgStateListRed[this.curFrameIdxRed] === false)
        if (this.imgStateListRed[this.curFrameIdxRed] === undefined) {
          this.curFrameIdxRed = idxBackup
        }
        break
      case 0:
        idxBackup = this.curFrameIdxBlue
        do {
          this.curFrameIdxBlue++
          if (this.curFrameIdxBlue >= 126) {
            this.curFrameIdxBlue = 0
          }
        } while (this.imgStateListBlue[this.curFrameIdxBlue] === false)
        if (this.imgStateListBlue[this.curFrameIdxBlue] === undefined) {
          this.curFrameIdxBlue = idxBackup
        }
        break
      case 1:
        idxBackup = this.curFrameIdxRed
        do {
          this.curFrameIdxRed++
          if (this.curFrameIdxRed >= 131) {
            this.curFrameIdxRed = 0
          }
        } while (this.imgStateListRed[this.curFrameIdxRed] === false)
        if (this.imgStateListRed[this.curFrameIdxRed] === undefined) {
          this.curFrameIdxRed = idxBackup
        }
        break
      case 2:
        idxBackup = this.curFrameIdxGreen
        do {
          this.curFrameIdxGreen++
          if (this.curFrameIdxGreen >= 125) {
            this.curFrameIdxGreen = 0
          }
        } while (this.imgStateListGreen[this.curFrameIdxGreen] === false)
        if (this.imgStateListGreen[this.curFrameIdxGreen] === undefined) {
          this.curFrameIdxGreen = idxBackup
        }
        break
      default:
        break
      }
    }, 41)

  },
  destroyed() {
    clearInterval(this.intervalId)
  },
  methods: {
    onClickExhibTabBtn(idx) {
      this.$store.commit("setSelectedTreeTabIdx", idx)
    },
    onClickTip() {
      this.$store.commit("recordShownTreeSelectionPageTip")
    },
    onImgLoad(treeColor, idx) {
      switch (treeColor) {
      case 'blue':
        this.imgStateListBlue[idx] = true
        break
      case 'red':
        this.imgStateListRed[idx] = true
        break
      case 'green':
        this.imgStateListGreen[idx] = true
        break
      default:
        break
      }
    },
    onImgError(treeColor, idx) {
      switch (treeColor) {
      case 'blue':
        this.imgStateListBlue[idx] = false
        break
      case 'red':
        this.imgStateListRed[idx] = false
        break
      case 'green':
        this.imgStateListGreen[idx] = false
        break
      default:
        break
      }
    }
  }
}
</script>

<style lang="less" scoped>
.tree-selection {
  position: absolute;
  width: 100%;
  height: 100%;
  .popup-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 2;
    .popup {
      box-sizing: border-box;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 13.72rem;
      height: 12.58rem;
      background: #F15835;
      border: 0.1rem solid #FFF600;
      border-radius: 0.3rem;
      padding: 1.13rem 1.13rem 0.72rem 1.06rem;
      h3 {
        font-size: 1.13rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 1.13rem;
      }
      p {
        font-size: 0.75rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 1.13rem;
        margin-bottom: 0.78rem;
      }
      .image-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 2.48rem;
        }
      }
    }
    .button-tip {
      animation: twinkle 2s infinite;
      position: absolute;
      bottom: 0.5rem;
      left: 50%;
      height: 2.48rem;
    }
    .button-tip-1 {
      transform: translateX(calc(-50% - 6rem));
    }
    .button-tip-2 {
      transform: translateX(-50%);
    }
    .button-tip-3 {
      transform: translateX(calc(-50% + 6rem));
    }
  }
  .tree-swiper {
    position: absolute;
    width: 100%;
    height: 100%;
    .title-wrapper {
      position: absolute;
      top: 2.14rem;
      left: 50%;
      transform: translateX(-50%);
      margin-right: auto;
      width: 8.91rem;
      height: 2.34rem;
      border-radius: 0.3rem;
      padding: 0.23rem;
      z-index: 2;
      .title {
        display: block;
        box-sizing: border-box;
        height: 100%;
        text-align: center;
        border: 0.05rem solid #FFFFFF;
        border-radius: 0.3rem;
        font-size: 0.94rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        &::after {
          content: '';
          height: 100%;
          vertical-align: middle;
          display: inline-block;
        }
      }
      &.theme {
        background: #18489D;
      }
      &.wuyiba {
        background: #F15835;
      }
      &.traditionModern {
        background: #2FB779;
      }
    }
    .tree-wrapper {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      height: 100%;
      width: 18.28rem;
      opacity: 0.1;
      z-index: 0;
      &.active {
        // animation: emerge 1s;
        opacity: 1;
        z-index: 1;
      }
      &.initial-active {
        opacity: 1;
        z-index: 1;
      }
      .tree {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        object-fit: contain;
      }
      .a {
        left: 10.5rem;
        bottom: 20.5rem;
      }
      .aa {
        left: 7rem;
        bottom: 23.5rem;
      }
      .ab {
        display: none;
      }
      .ac {
        display: none;
      }
      .ad {
        display: none;
      }
      .ae {
        display: none;
      }
      .b {
        left: 3.67rem;
        bottom: 18rem;
      }
      .c {
        left: 13.22rem;
        bottom: 16.5rem;
      }
      .d {
        left: 16.5rem;
        bottom: 16rem;
      }
      .e {
        left: 6.5rem;
        bottom: 11rem;
      }
      .f {
        left: 9rem;
        bottom: 16rem;
      }
      .g {
        left: 10rem;
        bottom: 18rem;
      }
      .h {
        left: 7rem;
        bottom: 23.8rem;
      }
      .i {
        left: 5rem;
        bottom: 18.5rem;
      }
      .j {
        left: 3rem;
        bottom: 20rem;
      }
      .k {
        left: 12.27rem;
        bottom: 13rem;
      }
      .l {
        left: 15.58rem;
        bottom: 12rem;
      }
      .m {
        left: 7rem;
        bottom: 12rem;
      }
      .n {
        left: 9.58rem;
        bottom: 10rem;
      }
      .oa {
        left: 12.5rem;
        bottom: 19rem;
      }
      .o {
        left: 10.5rem;
        bottom: 20.5rem;
      }
      .p {
        left: 7rem;
        bottom: 24.5rem;
      }
      .q {
        left: 3.67rem;
        bottom: 21rem;
      }
      .r {
        left: 17rem;
        bottom: 18rem;
      }
      .s {
        left: 5.6rem;
        bottom: 16rem;
      }
      .t {
        left: 8rem;
        bottom: 13.2rem;
      }
      .u {
        left: 10.5rem;
        bottom: 13.2rem;
      }
      .v {
        left: 15.5rem;
        bottom: 11rem;
      }
      .w {
        left: 3rem;
        bottom: 8rem;
      }
      .x {
        left: 1rem;
        bottom: 4.5rem;
      }
      .y {
        left: 15rem;
        bottom: 4rem;
      }
      .z {
        left: 11.47rem;
        bottom: 4rem;
      }
      .za {
        left: 8.5rem;
        bottom: 5rem;
      }
      .zb {
        left: 15rem;
        bottom: 18.5rem;
      }
      .zc {
        left: 0.8rem;
        bottom: 12.5rem;
      }
      .zd {
        left: 13.5rem;
        bottom: 12.5rem;
      }
    }
  }
  nav {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 1.64rem;
    height: 1.88rem;
    width: 18.5em;
    display: flex;
    border-radius: 0.94rem;
    overflow: hidden;
    z-index: 1;
    button {
      font-size: 0.75rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      width: 33.333%;
      flex: 1 0 auto;
      border: none;
    }
    button.theme {
      background: #18489D;
    }
    button.wuyiba {
      background: #F15835;
    }
    button.traditionModern {
      background: #2FB779;
    }
  }
}
@keyframes emerge {
  50% {
    transform: translateX(-50%) scale(1.3);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes twinkle {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
